<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="nome"
    item-value="id"
    label="Tags"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:selection="{attrs, selected, item}">
      <template>
        <v-chip
          v-bind="attrs"
          :input-value="selected"
        >
          <v-avatar left>
            <tw-tag-color :cor="item.cor"/>
          </v-avatar>
          {{ item.nome }}
        </v-chip>
      </template>
    </template>
    <template v-slot:item="{item}">
      <template>
        <v-list-item-avatar>
          <tw-tag-color :cor="item.cor"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item.nome"/>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import TagService from '@/api/tag-service';
import TagColor from '@/modules/tag/TagColor.vue';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value(newValue, oldValue) {
      if (newValue === oldValue || !newValue || !newValue.id) {
        return;
      }
      if (!this.items || !this.items.length) {
        this.items = [newValue];
        return;
      }
      const exists = this.items.find((i) => i.id === newValue.id);
      if (exists) {
        return;
      }
      this.items.push(newValue);
    },
  },
  methods: {
    remove(item) {
      const index = this.localValue.findIndex((a) => a.id === item.id);
      if (index >= 0) this.localValue.splice(index, 1);
    },
    searchData(val) {
      if (this.localValue && this.localValue.nome === val) {
        return;
      }

      this.loading = true;

      const query = `(nome like "%${(val || '').toLowerCase()}%") order by nome asc`;

      TagService.list({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
  components: {
    TwTagColor: TagColor,
  },
  created() {
    this.debounceSearch = debounce(this.searchData, 100);
    if (this.value) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
